<template>
  <div class="gift-card" :class="`gift-card--${variant}`">
    <!-- testata: logo del prodotto a sinistra, categoria a destra -->
    <div class="gift-card__heading">
      <img v-if="logo_src" class="gift-card__logo" :src="logo_src" alt="" />
      <p class="gift-card__category">{{ category }}</p>
    </div>

    <!-- parte bassa: riquadro contenuto (vuoto per ora) + footer -->
    <div class="gift-card__bottom">
      <div class="gift-card__box">
        <slot></slot>
      </div>
      <div class="gift-card__footer">
        <span class="gift-card__code">
          <span class="gift-card__code-label">Codice:</span> {{ code }}
        </span>
        <span class="gift-card__validity">{{ validity }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'gift-card',

    props: {
      // aspetto della card: chiara (selezione) o blu piena (prodotto scelto)
      variant: {
        type: String,
        default: 'light',
        validator: (value) => ['light', 'primary'].includes(value),
      },
      // categoria mostrata in testata, a destra del logo: come la validità,
      // la porta chi monta la card (su livegift è `product.category`)
      category: {
        type: String,
        default: '',
      },
      // codice (mascherato) mostrato nel footer
      code: {
        type: String,
        default: '•••• - •••• - ••••',
      },
      // validità mostrata nel footer: la porta chi monta la card (su livegift
      // è VALIDITY_LABEL). Senza, il footer resta col solo codice.
      validity: {
        type: String,
        default: '',
      },
      // path dell'SVG del marchio di prodotto; senza, la testata resta senza logo
      logo_src: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style lang="scss" scoped>

  .gift-card {
    width: 100%;
    padding: $grid-gutter-width;
    border: 1px solid $gray-300;
    border-radius: $border-radius-lg * 4;
    background-image: linear-gradient(
        151deg,
        $white 0%,
        rgba(#d3d1d1, 0.4) 100%
    );

    &__heading {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: $grid-gutter-width;

      @include media-breakpoint-up(md) {
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
      }

      @include media-breakpoint-up(lg) {
        flex-direction: column;
        margin-bottom: $grid-gutter-width;
      }

      @include media-breakpoint-up(xl) {
        flex-direction: row;
        margin-bottom: $grid-gutter-width * 2;
      }
    }

    // l'SVG statico porta le sue dimensioni intrinseche: qui si contiene,
    // come faceva il wrapper del componente <logo>
    &__logo {
      display: block;
      width: min(180px, 32vw);
      max-height: 60px;
      object-fit: contain;

      @include media-breakpoint-down(md) {
        width: min(180px, 45vw);
      }
    }

    &__category {
      margin: ($grid-gutter-width / 2) 0 0;
      color: $gray-900;
      line-height: normal;

      @include media-breakpoint-up(md) {
        text-align: right;
        margin: 0;
      }

      @include media-breakpoint-up(lg) {
        margin: ($grid-gutter-width / 2) 0 0;
        padding-left: $grid-gutter-width / 2;
      }

      @include media-breakpoint-up(xl) {
        margin: 0;
        padding-left: 0;
      }
    }

    &__box {
      min-height: 60px;
      padding: $grid-gutter-20 ($grid-gutter-width / 2);
      border-radius: $border-radius-lg * 2;
      background-color: rgba($white, 0.4);
    }

    &__footer {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      padding-top: $grid-gutter-width / 2;
      font-size: $font-size-md;
      color: $gray-900;
      line-height: normal;
    }

    &__code,
    &__validity {
      opacity: .5;
    }

    // variante blu: la card del prodotto scelto
    &--primary {
      border: 0;
      background-image: linear-gradient(149deg, $primary 0%, $primary 50%, #065890 100%);
      box-shadow: 0 10px 7.5px rgba($black, .1);

      .gift-card__category {
        font-size: $font-size-lg;
        color: $white;
      }

      .gift-card__box {
        padding: $grid-gutter-width / 2;
        background-color: rgba($white, .2);
      }

      .gift-card__footer {
        font-size: $font-size-base;
        color: $white;
      }

      .gift-card__code,
      .gift-card__validity {
        opacity: .7;
      }
    }
  }
</style>
